import { Pipe, PipeTransform } from '@angular/core';

import { DecimalFormatPipe, CurrencyFormatPipe, PercentFormatPipe } from '../number-format';
import { isLancamentoValor, isLancamentoPercentual } from '../../../models/lancamento';

/**
 * Pipe para formatar valores com base no lançamento informado
 */
@Pipe({
    name: 'lancamentoFormat'
})
export class LancamentoFormatPipe implements PipeTransform {

    constructor(private decimalFormatPipe: DecimalFormatPipe,
                private currencyFormatPipe: CurrencyFormatPipe,
                private percentFormatPipe: PercentFormatPipe) { }

    transform(value: number,
              lancamento: number,
              minIntegerDigits: number = 1,
              minFractionDigits: number = 0,
              maxFractionDigits: number = 0,
              minIntegerDigitsValor: number = 1,
              minFractionDigitsValor: number = 0,
              maxFractionDigitsValor: number = 0,
              minIntegerDigitsPercentual: number = 1,
              minFractionDigitsPercentual: number = 2,
              maxFractionDigitsPercentual: number = 2,
              nullIsZero = false) {
        // Valor
        if (isLancamentoValor(lancamento)) {
            return this.currencyFormatPipe.transform(value, minIntegerDigitsValor, minFractionDigitsValor, maxFractionDigitsValor);
        }
        // Percentual
        if (isLancamentoPercentual(lancamento)) {
            return this.percentFormatPipe.transform(value, minIntegerDigitsPercentual, minFractionDigitsPercentual, maxFractionDigitsPercentual, nullIsZero);
        }
        // Decimal
        return this.decimalFormatPipe.transform(value, minIntegerDigits, minFractionDigits, maxFractionDigits, nullIsZero);
    }
}
